import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-alarms-status-minor",
  "use": "app-icon-alarms-status-minor-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-alarms-status-minor\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FAFBFF\" cx=\"8\" cy=\"8\" r=\"8\" /><path d=\"M9 11v2H7v-2h2zm0-8v1.5L8.5 10h-1L7 4.5V3h2z\" fill=\"#FDCA5A\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol